import { render } from "./Home.vue?vue&type=template&id=74d5e08c&bindings={\"list\":\"setup\",\"login\":\"setup\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script